export const BASE_BOOK_CALL_URL =
  'https://calendly.com/kanda-sales/find-out-more-about-kanda-pre-sign-up';
